module.exports = __webpack_public_path__ + "static/media/S35.44e99c92.png";